/**
 * @generated SignedSource<<37bc78fbbd9795865975fbc7553ba4c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentStatus = "CANCEL" | "INFO" | "PAID" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type PaymentStatus_payment$data = {
  readonly status: PaymentStatus;
  readonly " $fragmentType": "PaymentStatus_payment";
};
export type PaymentStatus_payment$key = {
  readonly " $data"?: PaymentStatus_payment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentStatus_payment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentStatus_payment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Payment",
  "abstractKey": null
};

(node as any).hash = "286bae42deb7fea570a4e26dbf1579d8";

export default node;
